import { FilenameConvention } from 'src/app/models/filename-conventions/filename-convention';

export function filterRangeConventions(conventions: FilenameConvention[]): FilenameConvention[] {
  return conventions.filter((c) => c.value.payload.mode === 'rangeBased');
}

export function filterEvConventions(conventions: FilenameConvention[]): FilenameConvention[] {
  return conventions.filter((c) => c.value.payload.mode === 'evBased');
}
